/**
 * Zod schemas for Automation Task plugin - task type, JSON payload, and automation result data.
 */
import { z } from "zod";
/**
 * Configuration schema for the automation task step type.
 */
export const configSchema = z.object({
    taskType: z.string().min(1, "Task type is required"),
    payload: z.record(z.unknown()).default({}),
    description: z.string().optional(),
});
/**
 * Data schema for automation task step execution.
 */
export const dataSchema = z.object({
    automationResult: z.record(z.unknown()).optional(),
    error: z.string().optional(),
});
export const defaultConfig = {
    taskType: "",
    payload: {},
};
//# sourceMappingURL=schema.js.map